<template>
  <el-dialog :title="title" width="600px" :before-close="handleCancel" :visible.sync="isVisible">
    <el-form
      label-position="right"
      label-width="150px"
      ref="hookForm"
      :model="hookForm"
      :rules="rules"
    >
      <el-form-item label="Song name" prop="title">
        <el-input v-model="hookForm.title"></el-input>
      </el-form-item>
      <el-form-item label="Artist" prop="artist">
        <el-input v-model="hookForm.artist"></el-input>
      </el-form-item>
      <el-form-item label="Description" prop="description">
        <el-input type="textarea" v-model="hookForm.description"></el-input>
      </el-form-item>
      <el-form-item label="File" prop="file" :file-list="currentFile">
        <div v-if="hookForm.fileUrl">
          <el-card style="margin: 4px 0" shadow="never">
            <hook-media :hook="hookMeta"></hook-media>
          </el-card>
        </div>
        <el-upload
          ref="upload"
          action="https://jsonplaceholder.typicode.com/posts/"
          accept="audio/mpeg, audio/mp4, audio/ogg, audio/vorbis, audio/vnd.wav"
          name="file_data"
          class="post-file-upload"
          :on-change="handleFileChange"
          :auto-upload="false"
          :multiple="false"
        >
          <el-button size="small" type="primary">
            <i class="el-icon-upload"></i> Click to upload hook</el-button
          >
        </el-upload>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">Cancel</el-button>
      <el-button
        type="primary"
        :loading="hooksCreating || hooksSaving"
        :disabled="hooksCreating || hooksSaving"
        @click="handleSave"
        >{{ hookForm.id ? 'Save' : 'Create' }}</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex';

import HelpText from '@/components/common/HelpText';
import HookMedia from '@/components/surveybuilder/editors/music/HookMedia';

import * as surveyBuilderTypes from '@/store/modules/surveybuilder/mutation-types';

export default {
  name: 'HookSaveDialog',
  components: {
    HelpText,
    HookMedia,
  },
  data: () => ({
    hookForm: {},
    hookMeta: null,
    rules: {
      title: [
        { required: true, message: 'Please enter a song name', trigger: 'blur' },
        { min: 3, message: 'Length should be a minimum of 3 characters', trigger: 'blur' },
      ],
      artist: [
        { required: true, message: 'Please enter an artist', trigger: 'blur' },
        { min: 3, message: 'Length should be a minimum of 3 characters', trigger: 'blur' },
      ],
    },

    fileData: null,
  }),
  computed: {
    ...mapState('surveybuilder', ['hookDialogForm', 'hooksCreating', 'hooksSaving']),

    title() {
      return this.hookForm.id ? 'Edit hook' : 'Add new hook';
    },

    currentFile() {
      if (!this.hookForm || !this.hookForm.fileUrl) {
        return [];
      }

      const fileName = this.hookForm.fileUrl.substring(
        this.hookForm.fileUrl.lastIndexOf('/') + 1,
        this.hookForm.fileUrl.lastIndexOf('?'),
      );
      return [{ name: fileName, url: this.hookForm.fileUrl }];
    },

    isVisible: {
      get() {
        return this.$store.state.surveybuilder.hookDialogVisible;
      },
      set(value) {
        this.$store.commit(`surveybuilder/${surveyBuilderTypes.SET_HOOK_DIALOG_VISIBILITY}`, value);
      },
    },
  },
  mounted() {
    this.initForm();
  },
  methods: {
    initForm() {
      this.hookForm = { ...this.hookDialogForm.mediaClip };
      this.hookMeta = { ...this.hookForm };
    },

    resetForm() {
      this.initForm();
      this.$refs.hookForm.resetFields();
      this.hookMeta = null;
      this.$store.commit(`surveybuilder/${surveyBuilderTypes.RESET_HOOK_DIALOG_FORM}`);
      this.$store.commit(`surveybuilder/${surveyBuilderTypes.SET_HOOK_DIALOG_VISIBILITY}`, false);
      this.currentFile = [];
      this.$refs.upload.clearFiles();
    },

    handleCancel() {
      this.resetForm();
    },

    handleSave() {
      this.$refs.hookForm.validate(valid => {
        if (valid) {
          if (this.hookForm.id) {
            this.handleEdit();
          } else {
            this.handleCreate();
          }
        }
      });
    },

    handleEdit() {
      this.$store.dispatch('surveybuilder/updateHook', { hook: this.hookForm }).then(() => {
        this.resetForm();
        this.isVisible = false;
      });
    },

    handleCreate() {
      this.$store
        .dispatch('surveybuilder/createHook', {
          hook: this.hookForm,
        })
        .then(() => this.resetForm());
    },

    handleFileChange(file) {
      this.hookForm.fileData = file.raw;
    },
  },
  watch: {
    hookDialogForm() {
      this.initForm();
    },
  },
};
</script>



// WEBPACK FOOTER //
// HookSaveDialog.vue?ab5e4d58